module.exports = __webpack_public_path__ + "static/media/ad.f790cc54.svg";